import "@/App.css";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Cursor } from "@/components/Cursor";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Showreel } from "@/components/Showreel";
import { Contact } from "@/components/Contact";

function App() {
  return (
    <div className="App grain">
      <SmoothScroll>
        <Cursor />
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <Showreel />
          <Contact />
        </main>
      </SmoothScroll>
    </div>
  );
}

export default App;
